module.exports = __webpack_public_path__ + "static/media/Montserrat-Medium.d194e509.woff";